const linkStyle = {
  primary: 'leading-5 underline text-accent font-primary font-light',
  secondary: 'leading-5 underline text-black hover:text-accent font-primary font-light',
};

export { linkStyle };
